var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRwanda(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_33932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 14.0789 0.528891 16.0343 1.45908 17.7392L12 18.7827L22.5409 17.7392C23.4711 16.0343 24 14.0789 24 12L12 10.9565L0 12Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5409 6.26086C20.5057 2.53073 16.5485 0 12 0C7.45148 0 3.49434 2.53073 1.45908 6.26086C0.528891 7.96575 0 9.92109 0 12H24C24 9.92109 23.4711 7.96575 22.5409 6.26086Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 24C16.5484 24 20.5056 21.4693 22.5408 17.7391H1.45898C3.49425 21.4693 7.45139 24 11.9999 24Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5654 7.02287L15.031 7.71226L14.2506 9.13163L15.842 8.82723L16.0437 10.4348L17.1521 9.25243L18.2606 10.4348L18.4622 8.82723L20.0536 9.13154L19.2732 7.71221L20.7387 7.02287L19.2732 6.33357L20.0536 4.91419L18.4622 5.2186L18.2605 3.61102L17.1521 4.7934L16.0436 3.61102L15.842 5.2186L14.2506 4.91419L15.031 6.33362L13.5654 7.02287Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_33932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/ec893d29.svg";
export { SvgRwanda as ReactComponent };